import React from 'react';
import ErrorContainer from '../components/ErrorContainer';
import ErrorMessage from '../components/ErrorMessage';
import { FieldValidationErrorsType } from '../form/FrekulForm';

/**
 * テキスト入力
 */
function CustomTextInputView({
  dataType,
  placeholder,
  disabled,
  value,
  setValue,
  onGainFocus,
  onLoseFocus,
}: {
  dataType: string,
  placeholder: string,
  disabled: boolean,
  value: string,
  setValue: (value: string) => void,
  onGainFocus: () => void,
  onLoseFocus: () => void,
}) {
  let type = 'text';
  let inputMode: 'numeric'|null = null;
  let pattern: string|null = null;

  switch (dataType) {
    case 'any':
      break;
    case 'password':
      type = 'password';
      break;
    case 'digits':
      inputMode = 'numeric';
      pattern = '[0-9]*';
      break;
    default:
      break;
  }

  return (
    <input
      className="form__textArea_size"
      type={type}
      inputMode={inputMode || undefined}
      pattern={pattern || undefined}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      onChange={(e) => setValue(e.target.value)}
      onFocus={() => onGainFocus()}
      onBlur={() => onLoseFocus()}
    />
  );
}

export default function CustomTextInput({
  dataType = 'any',
  placeholder = '',
  value,
  setValue,
  disabled = false,
  validationWarnings = {},
  validationErrors = {},
}: {
  dataType?: string,
  placeholder?: string,
  value: string,
  setValue: (value: string) => void,
  disabled?: boolean,
  validationWarnings?: FieldValidationErrorsType,
  validationErrors?: FieldValidationErrorsType,
}) {
  const [focused, setFocused] = React.useState(false);
  const [currentValidationErrors, setCurrentValidationErrors] = React.useState(validationErrors);
  const [currentValidationWarnings, setCurrentValidationWarnings] = React.useState(validationWarnings);
  React.useEffect(() => {
    if (!focused) {
      if (JSON.stringify(validationErrors) !== JSON.stringify(currentValidationErrors)) {
        setCurrentValidationErrors(validationErrors);
      }
      if (JSON.stringify(validationWarnings) !== JSON.stringify(currentValidationWarnings)) {
        setCurrentValidationWarnings(validationWarnings);
      }
    }
  }, [validationErrors, validationWarnings, focused]);
  return (
    <>
      <ErrorContainer
        isValid={!focused && value !== '' &&  Object.keys(validationErrors).length === 0 && Object.keys(validationWarnings).length === 0}
        isWarning={!focused && value !== '' && Object.keys(validationWarnings).length > 0}
        isError={!focused && value !== '' && Object.keys(validationErrors).length > 0}
      >
        <CustomTextInputView
          dataType={dataType}
          placeholder={placeholder}
          value={value}
          setValue={setValue}
          disabled={disabled}
          onGainFocus={() => setFocused(true)}
          onLoseFocus={() => setFocused(false)}
        />
      </ErrorContainer>
      <ErrorMessage type="warning" validationErrors={currentValidationWarnings} />
      <ErrorMessage type="error" validationErrors={currentValidationErrors} />
    </>
  );
}

